/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';

export interface IBloodBank {
  id?: string;
  name?: string | null;
  registrationCode?: string | null;
  registrationAuth?: string | null;
  registrationState?: string | null;
  email?: string | null;
  returnInstructions?: string | null;
  taxCode?: string | null;
  billPrefix?: string | null;
  createdBy?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  hospital?: IHospital | null;
  user?: IUser | null;
  contactCode?: IContactDetails | null;
}

export const defaultValue: Readonly<IBloodBank> = {
  active: false,
};
